// extracted by mini-css-extract-plugin
module.exports = {"section":"creditssection-module--section--2vOMe","hed":"creditssection-module--hed--E_lnR"};